// @flow
import {defineMessages} from 'react-intl';

const messages = defineMessages({
  web: {
    id: 'docsApp.components.acceptPaymentSelector.web',
    description: 'Label for a button to select platform',
    defaultMessage: 'Web',
  },
  ios: {
    id: 'docsApp.components.acceptPaymentSelector.ios',
    description: 'Label for a button to select platform',
    defaultMessage: 'iOS',
  },
  android: {
    id: 'docsApp.components.acceptPaymentSelector.android',
    description: 'Label for a button to select platform',
    defaultMessage: 'Android',
  },
  reactNative: {
    id: 'docsApp.components.acceptPaymentSelector.reactNative',
    description: 'Label for a button to select platform',
    defaultMessage: 'React Native',
  },
  plugins: {
    id: 'docsApp.components.acceptPaymentSelector.plugins',
    description: 'Label for a button to select platform',
    defaultMessage: 'Web platform or CMS',
  },
  checkout: {
    id: 'docsApp.components.acceptPaymentSelector.checkout',
    description: 'Label for a button to select ui',
    defaultMessage: 'Prebuilt Checkout page',
  },
  elements: {
    id: 'docsApp.components.acceptPaymentSelector.elements',
    description: 'Label for a button to select ui',
    defaultMessage: 'Custom payment flow',
  },
});

export default messages;
